import React from "react";
import Loader from 'react-loader-spinner'
import MultiSelectInput from "../../components/inputs/MultiSelectInput";
import SelectInput from "../../components/inputs/SelectInput";
import { translate } from "../../utils/useful";


class AddPermissionUsers extends React.Component {
  state = {
    isLoadingRemove: false,
    id: null,
    index: null,
    image: ''
  }


  componentDidMount() {
    // this.changeImage()
    //  this.interval = setInterval(() => {
    //   this.changeImage()
    // }, 1500);
  }


  componentWillUnmount() {
    clearInterval(this.interval)
  }

  changeImage = () => {
    let number = Math.floor(Math.random() * this.images.length - 1)
    if (this.images[number]) {
      let image = this.images[number]
      this.setState({ image })
    }
  }

  // hideModal = () => {
  //   this.removeModal.hideModal()
  // }


  render() {
    return (
      <div className="" style={{}}>
        <div className="flexcc flex-column py-2  px-4" style={{ borderRadius: '8px 8px 0px 0px', background: 'linear-gradient(to  top,rgb(0, 122, 255), rgb(40, 102, 245))' }}>
          {/* <img src={'/images/password.svg'} alt="" width="40px" /> */}
          <p className="mt-1 text-big text-bold white">{translate("Add Permission")}</p>
        </div>
        <div className="px-3 pb-5">

          <p className="mt-3 text-small text-center ">{translate("You want to give new access to users or groups?")}</p>

          <div className="flexcc" style={{ backgroundColor: '#f2f6f8', borderRadius: 8, padding: '2px 4px' }}>
            <div className="flex-1">
              <SelectInput header={{ key: '', information: { type: 'local', default: 'Groups', items: [{ title: 'Groups', value: 'Groups' }, { title: 'Users', value: 'Users' }], placeholder: 'Search ...', required: true } }} />
            </div>
          </div>

          <div className="flexcc" style={{ backgroundColor: '#f2f6f8', borderRadius: 8, padding: '2px 4px' }}>
            <div className="flex-2">
              <MultiSelectInput header={{ key: '', information: { placeholder: 'Search ...' } }} />
            </div>

          </div>

          {/* <div>
            <p>Selected Users / Groups</p>
            {this.state.selected}

          </div> */}



          <div style={{ display: 'flex', justifyContent: 'center' }}>
            {this.props.isLoading && (
              <Loader
                type="Puff"
                color="rgba(0,122,255,1)"
                height="40"
                width="40"
              />)}
          </div>
        </div>
      </div>

    );
  }
}



export default AddPermissionUsers;
